import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "@onsip/web/modules/material/material.module";
import { AvatarModule } from "../../shared/components/avatar/avatar.module";
import { TableModule } from "../../shared/components/table/onsip-table.module";
import { TimerModule } from "../../shared/components/timer/timer.module";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { ManagerDashboardRoutingModule } from "./manager-dashboard-routing.module";
import { ManagerDashboardComponent } from "./manager-dashboard.component";

@NgModule({
  imports: [
    AvatarModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    PipesModule,
    TranslateModule,
    TableModule,
    TimerModule,
    ManagerDashboardRoutingModule
  ],
  declarations: [ManagerDashboardComponent],
  exports: [ManagerDashboardComponent]
})
export class ManagerDashboardModule {}
